import { RoutePaths } from '@global/routePaths';
import { NavigationGuard } from '@core/guards/navigation.guard';

export const ErrorRoutes = [
  {
    path: RoutePaths.NEW_QUOTATION.ERROR.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/error/error.module').then(m => m.ErrorPageModule),
    canActivate: [NavigationGuard],
  },
];
